import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledChip = styled('button')`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 16px;
  border: 1px solid ${COLOR.bluev2[24]};
  background: ${COLOR.bluev2[8]};
  color: ${COLOR.blueV2};
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  cursor: pointer;
  align-self: center;

  &:hover {
    background: ${COLOR.bluev2[16]};
  }
`;

export const StyledNoIssueChip = styled('span')`
  display: flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 100px;
  border: none;
  background: ${COLOR.greenV2[8]};
  color: ${COLOR.greenV2.default};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.4px;
  align-self: center;
`;
